/* 
Mono
console.log('⏳ evaluating', import.meta.url);
*/

import { qS } from './_default.js';

const error = {
  
  init: function(){
    qSA('.handle-error').forEach((container) => {
      container.querySelector('input').addEventListener('input', function(){
        container.classList.remove('input-error');
        if(container.querySelector('.error')){
          container.querySelector('.error').remove();
        }
      });
    });
  },

  handle: async function(result, container) {

    // If string is passed, get the element
    if(typeof(container) === "string"){
      container = qS("#"+container);
    }

    if(!container){
      console.error('Container not found');
      return;
    }

    if (result.error) {
      container.classList.add('input-error');
      let errorMessage = result.errorMessage || result.error;

      console.log('errorMessage', errorMessage);
      
      if(!container.querySelector('.error')){
        let errorContainer = document.createElement('div');
        errorContainer.classList.add('error');
        container.appendChild(errorContainer);
      }
      container.querySelector('.error').innerHTML = errorMessage;
      container.querySelector('.error').style.display = "block";

      // Enable submit button
      const submitButton = container.closest('form').querySelector('button[type="submit"]');
      if(submitButton){
        submitButton.disabled = false;
        submitButton.classList.remove('button-loading');
      }
      if(typeof(activity) !== 'undefined'){
        activity.log(activity.activityTypes.errorSeen, result.error);
      }
    }else if(container){
      container.classList.remove('input-error');
    }
  }

};

// Expose profile to the global object
window.error = error;

export { error };